import { styled } from "@mui/material/styles"
import { Switch as MUISwitch, SwitchProps } from "@mui/material"

const AntSwitch = styled(MUISwitch)(({ theme }: any) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#272D24",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#3ACF01",
      },
    },
    "&.Mui-disabled": {
      "+.MuiSwitch-track": {
        backgroundColor: "#FFFFFF80",
      },
      ".MuiSwitch-thumb": {
        backgroundColor: "#000",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    backgroundColor: "#272D24",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#FFFFFF80",
    boxSizing: "border-box",
  },
}))

const Switch = (props: SwitchProps) => {
  return <AntSwitch {...props} />
}

export default Switch
